/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NftRewardPrize,
    NftRewardPrizeFromJSON,
    NftRewardPrizeFromJSONTyped,
    NftRewardPrizeToJSON,
} from './';

/**
 * 
 * @export
 * @interface RedeemNftRewardResponse
 */
export interface RedeemNftRewardResponse {
    /**
     * 
     * @type {NftRewardPrize}
     * @memberof RedeemNftRewardResponse
     */
    nftPrize: NftRewardPrize;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    promoName?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    trackerName?: string;
}

export function RedeemNftRewardResponseFromJSON(json: any): RedeemNftRewardResponse {
    return RedeemNftRewardResponseFromJSONTyped(json, false);
}

export function RedeemNftRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemNftRewardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nftPrize': NftRewardPrizeFromJSON(json['nftPrize']),
        'promoName': !exists(json, 'promoName') ? undefined : json['promoName'],
        'promoCode': !exists(json, 'promoCode') ? undefined : json['promoCode'],
        'trackerName': !exists(json, 'trackerName') ? undefined : json['trackerName'],
    };
}

export function RedeemNftRewardResponseToJSON(value?: RedeemNftRewardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nftPrize': NftRewardPrizeToJSON(value.nftPrize),
        'promoName': value.promoName,
        'promoCode': value.promoCode,
        'trackerName': value.trackerName,
    };
}


